<div class="container">
  <div class="card mb-4">
    <div *ngIf="topSection.titleKey" class="card-header">{{ 'explore.index.' + topSection.titleKey | translate }}</div>
    <div *ngIf="!topSection.titleKey" class="card-header">{{ 'explore.index.' + topSection.sortField | translate }}</div>
    <div class="card-body p-0">
      <ds-themed-browse-most-elements [context]="context" [paginatedSearchOptions]="paginatedSearchOptions"></ds-themed-browse-most-elements>
    </div>
  </div>
</div>